import React from 'react';
import { Shield, PhoneCall, TrendingUp, Search, ArrowRight, CheckCircle, Globe, Zap } from 'lucide-react';
import './App.css';

function App() {
  return (
    <div className="agency-site">
      {/* Header */}
      <header className="nav-header">
        <div className="logo">BENCORP GLOBAL AI</div>
        <nav>
          <a href="#services">Services</a>
          <a href="#lab">The Lab</a>
          <a href="#case-studies">Risk Reports</a>
          <button className="cta-small">Book Briefing</button>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="badge">GLOBAL AGENCY · SF · LONDON · DUBAI</div>
          <h1>Institutional Modernization. <span className="highlight">Guaranteed.</span></h1>
          <p className="subheadline">
            We deploy proprietary AI infrastructure to secure compliance, automate voice operations, 
            and optimize capital for high-end hospitality, construction, and finance groups.
          </p>
          <div className="hero-ctas">
            <button className="cta-primary">Run Institutional Audit <ArrowRight size={20} /></button>
            <button className="cta-secondary">View Voice Demo</button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="section-header">
          <h2>Our Core Engines</h2>
          <p>Cutting-edge automation for traditional industries.</p>
        </div>
        <div className="service-grid">
          <div className="service-card">
            <Shield className="icon" size={40} color="#FFD700" />
            <h3>AI Compliance Auditor</h3>
            <p>Automated identification of GDPR, EU AI Act, and data protection gaps with instant risk-reduction roadmaps.</p>
          </div>
          <div className="service-card">
            <PhoneCall className="icon" size={40} color="#FFD700" />
            <h3>Voice AI Assistants</h3>
            <p>Institutional-grade outbound and inbound voice agents for lead qualification and coordination.</p>
          </div>
          <div className="service-card">
            <TrendingUp className="icon" size={40} color="#FFD700" />
            <h3>Quant Trading Engines</h3>
            <p>High-alpha algorithmic execution for liquidity management and institutional capital growth.</p>
          </div>
        </div>
      </section>

      {/* The Hook: Live Case Study / Risk Reports */}
      <section id="case-studies" className="risk-reports">
        <div className="reports-container">
          <div className="reports-text">
            <h2>Real-Time Risk Analysis</h2>
            <p>We've analyzed the digital infrastructure of leading groups in London and Dubai. The results show massive regulatory exposure.</p>
            <ul className="lead-results">
              <li><CheckCircle size={18} color="#FFD700" /> <strong>Dubai Hospitality:</strong> €30M+ potential liability identified.</li>
              <li><CheckCircle size={18} color="#FFD700" /> <strong>London Construction:</strong> Critical GDPR disclosure gaps found.</li>
              <li><CheckCircle size={18} color="#FFD700" /> <strong>Global Standard:</strong> EU AI Act transparency requirements missed.</li>
            </ul>
            <button className="cta-outline">View Full Lead Report</button>
          </div>
          <div className="report-visual">
            <div className="scan-card">
              <div className="scan-header">
                <Globe size={20} /> Scanning: sunsethospitality.com
              </div>
              <div className="score">6/10</div>
              <div className="gaps">
                <div className="gap-item">No GDPR Banner <span className="high">HIGH RISK</span></div>
                <div className="gap-item">No AI Disclosure <span className="med">MEDIUM</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lab Integration */}
      <section id="lab" className="lab-section">
        <div className="lab-card">
          <Zap size={48} color="#FFD700" />
          <h2>The Bencorp AI Lab</h2>
          <p>Our internal R&D engine is now open for institutional partners. Get access to our suite of audit and voice tools.</p>
          <a href="https://bencorp-audit-portal.pages.dev" className="lab-link" target="_blank" rel="noopener noreferrer">
            Enter the Lab <ArrowRight size={20} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">BENCORP GLOBAL</div>
          <div className="footer-links">
            <p>© 2026 Bencorp AI & Automation | Lusaka · London · Dubai · SF</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
